import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [statusFilter, setStatusFilter] = useState('All');
  const [loading, setLoading] = useState(true);
  const [dark, setDark] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchPlans = async () => {
      setLoading(true);
      try {
        const res = await fetch('https://api.mogym.ir/api/admin/plans', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.Message);
        setPlans(data.Result || []);
      } catch {
        setError('دریافت لیست برنامه‌ها با خطا مواجه شد.');
      }
      setLoading(false);
    };

    fetchPlans();
  }, []);

  const filteredPlans = statusFilter === 'All'
    ? plans
    : plans.filter(p => p.Status === statusFilter);

  const statusColor = (status) => {
    switch (status) {
      case 'Registered': return 'text-white-500';
      case 'Paid': return 'text-orange-500';
      case 'Canceled': return 'text-red-500';
      case 'PaymentPending': return 'text-yellow-500';
      case 'Created': return 'text-green-500';
      case 'TrainerReview': return 'text-blue-500';
      default: return 'text-gray-400';
    }
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-5xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-4">مدیریت برنامه‌ها</h1>

          {/* فیلتر وضعیت */}
          <div className="flex justify-center gap-3 flex-wrap mb-4">
            {['All', 'Registered', 'Paid', 'Canceled', 'PaymentPending','Created','TrainerReview'].map((s) => (
              <button
                key={s}
                className={`px-3 py-1 rounded-full border dark:border-gray-600 text-sm ${
                  statusFilter === s ? 'bg-blue-600 text-white' : 'bg-gray-100 dark:bg-[#2a2f3b]'
                }`}
                onClick={() => setStatusFilter(s)}
              >
                {s === 'All' ? 'همه' : s}
              </button>
            ))}
          </div>

          {loading && <p className="text-center">در حال دریافت برنامه‌ها...</p>}
          {error && <p className="text-red-500 text-center">{error}</p>}

          {/* لیست برنامه‌ها */}
          <div className="space-y-4">
            {filteredPlans.map((item, idx) => (
              <div
                key={idx}
                className="border dark:border-gray-700 rounded-xl p-4 bg-gray-50 dark:bg-[#1c1f2b]"
              >
                <div className="flex justify-between items-center mb-2">
                  <div>
                    <p className="font-bold text-sm">{item.UserPhone}</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {item.PlanTitle} • {new Date(item.CreatedAt).toLocaleDateString('fa-IR')}
                    </p>
                  </div>
                  <span className={`text-sm font-medium ${statusColor(item.Status)}`}>
                    {item.Status}
                  </span>
                </div>

                <div className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  مبلغ: {item.Price?.toLocaleString()} تومان
                </div>

<button
  onClick={() => navigate(`/admin/plan/${item.PlanId}`)}
  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1 rounded-xl text-sm"
>
  مشاهده جزئیات
</button>

              </div>
            ))}
          </div>
        </div>

        {/* دکمه تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
